import React from 'react'

const InvoiceNotAvailable: React.FC = () => {
  return (
    <div className="text-base text-gray-700 mt-2 text-center w-72">
      <span className="text-sm font-normal italic">
        Invoice not available for bookings made through third-party channels.
      </span>
    </div>
  )
}

export default InvoiceNotAvailable
